import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { SelectProps } from './Select.types';

const Select = ({
  customWidthSelect = '',
  options,
  name,
  defaultValue,
  value,
  onChange,
  className = '',
  disabled = false,
  disableEmptyOption = false,
}: SelectProps) => {
  // 값이 없을 때 "선택" placeholder 자동 표시, 값이 있으면 숨김.
  // 단, 호출자가 이미 빈 값('') 옵션(예: "전체")을 제공한 경우엔 빈 칸 중복을
  // 막기 위해 자동 placeholder를 추가하지 않는다.
  const hasEmptyOption = options.some((option) => option.value === '');
  const showPlaceholder = (!value || value === '') && !hasEmptyOption;

  const { t } = useTranslation();

  return (
    <div className={cn(customWidthSelect, 'flex flex-col gap-2 w-full')}>
      <select
        id={name}
        name={name}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        className={cn(
          'select cursor-pointer max-w-full overflow-hidden whitespace-nowrap  text-ellipsis',
          className
        )}
        disabled={disabled}
      >
        {showPlaceholder && (
          <option value="" disabled={disableEmptyOption}>
            {t('cm > select db')}
          </option>
        )}
        {options.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={(option.value === '' && disableEmptyOption) || option.disabled}
            hidden={option.hidden}
            className="bg-db-card"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
